import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ZoningCode } from '../../../models/zoning-code';
import { ZoningCodeVersion } from '../../../models/zoning-code-version';
import { ZoningCodeVersionButtons } from '../../../models/zoning-code-version-buttons';
import { SetZcVersionPropertiesDialogComponent } from '../../dialogs/set-zc-version-properties-dialog/set-zc-version-properties-dialog.component';

@Component({
    standalone: false,
    selector: 'app-set-zc-version-last-updated-button',
    templateUrl: './set-zc-version-last-updated-button.component.html',
    styleUrls: ['./set-zc-version-last-updated-button.component.scss']
})
export class SetZcVersionLastUpdatedButtonComponent extends ZoningCodeVersionButtons {
    @Input()
    zoningCodeVersion: ZoningCodeVersion;

    @Input()
    zoningCode: ZoningCode;

    @Input()
    stateEnv: string;

    isOpenDialog = false;

    constructor(private readonly dialog: MatDialog, private readonly snackBar: MatSnackBar) {
        super();
    }

    ngOnInit(): void {}

    openLastUpdatedSelectionDialog(event: Event) {
        event.stopPropagation();
        if (this.isOpenDialog) {
            return;
        }
        this.isOpenDialog = true;

        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            zcVersionId: this.zoningCodeVersion.Id,
            stateEnv: this.stateEnv
        };
        dialogConfig.maxHeight = '650px';
        dialogConfig.width = '450px';
        dialogConfig.disableClose = true;

        this.dialog
            .open(SetZcVersionPropertiesDialogComponent, dialogConfig)
            .afterClosed()
            .subscribe(result => {
                if (!result) {
                    return;
                }
                this.snackBar.open(`Calculation Results were successfully updated`, 'OK', {
                    verticalPosition: 'top',
                    horizontalPosition: 'center',
                    duration: 2000
                });
            });
        this.isOpenDialog = false;
    }
}
